import React from 'react';
import { Heading, Slide } from 'spectacle-ppa';

function headingSlide ({
  id,
  bgColor,
  notes,
  heading,
  subHeading,
  beforeImage,
  afterImage,
  slideClass
}) {
  const slideContentClass = slideClass ? ' slide-' + slideClass : '';
  const bgColorOpts = {};
  if (bgColor) {
    bgColorOpts.bgColor = bgColor;
  }
  return (
    <Slide
        id={id}
        key={id}
        {...bgColorOpts}
        notes={notes}>
      <div className={'slide-content' + slideContentClass}>
        { !!beforeImage &&
          <div className="flex-image"><img
              className="heading-image heading-image-before"
              src={beforeImage} /></div>
        }
        <div className="text-heading">
          <Heading size={2}>
            <div dangerouslySetInnerHTML={{__html: heading}} />
          </Heading>
          { !!subHeading &&
            <Heading size={3}>
              <div dangerouslySetInnerHTML={{__html: subHeading}} />
            </Heading>
          }
        </div>
        { !!afterImage &&
          <img
              className="heading-image heading-image-after"
              src={afterImage} />
        }
      </div>
    </Slide>
  );
}

export default headingSlide;



// WEBPACK FOOTER //
// ./programs/epsPrimaries/baseSlides/headingSlide.js